import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/**
 * Angular migration of `systemMessageFactory`
 * (`GTW12/ui/app/components/admin/systemMessage/systemMessageService.js`).
 *
 * All URLs are read from `environment` instead of being passed in from a
 * legacy `@Input('base-urls')` setter — the host shell no longer provides
 * per-component config.
 */
@Injectable({ providedIn: 'root' })
export class SystemMessageService {
  constructor(private http: HttpClient) {}

  private get baseUrl(): string {
    return environment.base_url;
  }

  private get adminApiUrl(): string {
    return environment.admin_api_url;
  }

  /** Loads the application-wide user list used by the typeahead. */
  getAllUsers(): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/loadJsonObject?action_id=30815`,
      { withCredentials: true }
    );
  }

  /**
   * Loads all system & client notifications along with the supporting
   * `app_list` and `tax_type_list` reference data used to populate the
   * multi-selects on the edit form.
   */
  getAllSystemNotif(): Observable<any> {
    return this.http.get<any>(
      `${this.adminApiUrl}/getAllSystemNotif`,
      { withCredentials: true }
    );
  }

  /**
   * Persists a single notification record (create / update / archive toggle).
   * Mirrors the legacy `$http` call: payload is wrapped in `{ data: JSON.stringify([...]) }`.
   */
  saveSysMsg(payload: any[]): Observable<any> {
    return this.http.post<any>(
      `${this.adminApiUrl}/saveSysNotif`,
      { data: JSON.stringify(payload || []) },
      { withCredentials: true }
    );
  }
}
